import { Fragment, memo } from 'react'
import { useSelector } from 'react-redux';
import { DisclaimerSelector } from 'redux/selector';
import useApplyLocale from '../../hooks/useApplyLocale';
import DangerousMessage from 'components/Message/DangerousMessage'

const DisclaimerMessage = ({
  code, dangerous, htmlTag,
  textComponent: TextComponent,
  children,
  ...props
}) => {

  const disc = useSelector(state => DisclaimerSelector.disclaimerMessage(state, code));
  const discLocale = useApplyLocale({ th: disc, en: disc, fallback: 'th' })

  const renderDangerousHtml = () => {
    if (htmlTag) return <DangerousMessage className="custom-message-1" html={discLocale} htmlTag={htmlTag} {...props}/>
    else return <DangerousMessage.Div className="custom-message-1" html={discLocale} {...props}/>
  }

  if (typeof children === 'function') {
    return children(discLocale);
  } else {
    return !dangerous
      ? <TextComponent {...props}>{discLocale}</TextComponent>
      : renderDangerousHtml()
  }
}

export default memo(DisclaimerMessage);

DisclaimerMessage.defaultProps = {
  textComponent: Fragment,
}